import styled from 'styled-components';
import BloodHomeSvg from '@src/assets/imgs/blood-home/bloodHomeCard.svg';
import { useRouter } from 'next/router';
import { devices } from '@src/styles/theme';
const Poster = () => {
  const router = useRouter();
  return (
    <>
      {router.pathname === '/community/board' && (
        <BloodHomeWrap
          onClick={() => {
            router.push('/blood-home');
          }}
        >
          <BloodHomeText>
            <span>헌혈 센터 별</span> 리뷰가 궁금하다면?
          </BloodHomeText>
          <BloodHomeSubText>센터 리뷰 보러가기</BloodHomeSubText>
          <BloodHomeIcon />
        </BloodHomeWrap>
      )}
    </>
  );
};

const BloodHomeWrap = styled.div`
  border-radius: 10px;
  background: #ffe8e1;
  text-align: center;
  padding: 36px 26px;
  cursor: pointer;
  position: relative;
  margin-bottom: 15px;
`;

const BloodHomeText = styled.div`
  color: #262626;
  font-family: 'NOTO';
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px; /* 150% */
  letter-spacing: -0.72px;
  > span {
    color: var(--Pink-005, #ff4651);
  }
`;

const BloodHomeSubText = styled.div`
  margin-top: 7px;
  color: #262626;
  font-family: 'Regular';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
  letter-spacing: -0.6px;
`;

const BloodHomeIcon = styled(BloodHomeSvg)`
  width: 145.776px;
  height: 125px;
  position: absolute;
  right: 4%;
  top: 0;

  @media ${devices.tablet} {
    width: 75px;
    height: 68px;
    top: 40%;
  }
`;

export default Poster;
